import React from "react";
import {Box, ButtonBase, Tooltip, Typography} from "@mui/material";
import {alpha} from "@mui/material/styles";

// Escolha única em cartões com título e explicação (`UI.option` do protótipo). Opção desligada mostra o motivo.
export default function OpcoesEmCartao({rotulo, valor, opcoes, onEscolher, colunas = 2}) {
    return (
        <Box>
            {rotulo ? <Typography variant="caption" color="text.secondary" display="block" sx={{mb: 1}}>{rotulo}</Typography> : null}
            <Box role="radiogroup" aria-label={rotulo} sx={{display: 'grid', gap: 1.25, gridTemplateColumns: {xs: '1fr', sm: `repeat(${colunas}, minmax(0, 1fr))`}}}>
                {opcoes.map((opcao) => {
                    const marcada = opcao.value === valor;
                    const cartao = (
                        <ButtonBase
                            role="radio"
                            aria-checked={marcada}
                            aria-label={opcao.titulo}
                            disabled={opcao.disabled}
                            onClick={() => onEscolher(opcao.value)}
                            sx={(theme) => ({
                                display: 'block',
                                width: '100%',
                                height: '100%',
                                textAlign: 'left',
                                p: 1.5,
                                borderRadius: 1.5,
                                border: '1px solid',
                                borderColor: marcada ? 'primary.main' : 'divider',
                                bgcolor: marcada ? alpha(theme.palette.primary.main, 0.06) : 'background.paper',
                                boxShadow: marcada ? `0 0 0 1px ${theme.palette.primary.main}` : 'none',
                                opacity: opcao.disabled && !marcada ? 0.55 : 1,
                                transition: theme.transitions.create(['border-color', 'background-color']),
                                '&:hover': opcao.disabled ? {} : {borderColor: 'primary.main'},
                                '&.Mui-disabled': {pointerEvents: 'auto', cursor: 'not-allowed'},
                            })}
                        >
                            <Typography variant="body2" fontWeight={700} component="span" display="block">{opcao.titulo}</Typography>
                            {opcao.texto ? <Typography variant="caption" color="text.secondary" component="span" display="block">{opcao.texto}</Typography> : null}
                        </ButtonBase>
                    );
                    return opcao.disabled && opcao.motivo
                        ? <Tooltip key={opcao.value} title={opcao.motivo}><span>{cartao}</span></Tooltip>
                        : <React.Fragment key={opcao.value}>{cartao}</React.Fragment>;
                })}
            </Box>
        </Box>
    );
}
